import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { PageIndices } from '@/common/i-doc/i-doc.registry.ts';
import { PageHint } from '@components/common/PageHint.tsx';
import { renderClientProfileSection } from '@/components/clients/renderClientProfileSection';
import { ClientDetails } from '@/types/client';

// "Профіль" клієнта для продакт-менеджера (2026-10-29): той самий рендер секцій, що в Експерта
// (pages/expert/ClientPage.tsx, profile route) - "Системна інформація" перенесена сюди (прибрана
// з кабінету Експерта), "Загальна інформація" скопійована (лишається і в Експерта).
export const PmClientProfileTab: React.FC<{ client: ClientDetails }> = ({ client }) => {
  const { t } = useTranslation();

  return (
    <Box data-i-doc={PageIndices.PM_CLIENT_PROFILE}>
      <PageHint iDoc={PageIndices.PM_CLIENT_PROFILE} />
      {renderClientProfileSection(t('clientProfile.section.general'), client.general)}
      {renderClientProfileSection(t('clientProfile.section.system'), client.system)}
    </Box>
  );
};
